import { useNavigator } from '@repo/toolkit/use-navigator'
import { TeachingIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTefl } from '../../../api/tefl/create-tefl'
import UserNavBar from '../../../components/elements/nav-bar'
import TeflForm from '../../../components/pages/tefl/tefl-form'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import { Tefl } from '../../../lib/types/models/tefl/tefl'
import { TeflInput } from '../../../lib/types/models/tefl/tefl-input'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const TefelCreatePage = () => {
  const { navigate, back } = useNavigator()
  const { user } = useAuth()

  const { mutateAsync } = useMutation<Tefl | undefined, Error, TeflInput, unknown>({
    mutationFn: async (data) => {
      if (!user || !user.ol?.id || !data) return

      return createTefl(user.ol.id, data)
    },
    onError: showAxiosError,
    onSuccess: () => toast.success('TEFL created successfully')
  })

  return (
    <div>
      <UserNavBar title={'Add a new TEFL'} icon={TeachingIcon} />
      <div className={'h-4'} />
      <TeflForm
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const tefl = await mutateAsync(values)
            if (!tefl) return

            navigate(
              Paths.OL_TEFL_UPDATE_PAGE.replace(':id', tefl.id.toString()).replace(
                ':olId',
                tefl.olId.toString()
              ),
              { replace: true }
            )
          },
          onCancel: () => back(Paths.OL_TEFL_LIST_PAGE),
          isEnglish: true
        })}
      />
    </div>
  )
}

export default TefelCreatePage
